import { useEffect, useState } from "react"
import useAuth from "../../hooks/useAuthContext"
import Loader from "../../components/utilities/Loader/Loader"
import axiosInstance from "../../hooks/axiosInstance"
import { toast } from "react-toastify"
import AssociationSocials from "../../components/AssociationAdmin/Account/Socials"
import { Link } from "react-router-dom"
import { getCountries, getStatesByCountry, getCitiesByState } from "../../utils/getLocation"

export default function AssociationAdminProfilePage() {
    const { userData, fetchUserDetails } = useAuth()

    const [formData, setFormData] = useState({
        'name': '',
        'reg_number': '',
        'email': '',
        'country': '',
        'state': '',
        'city': '',
        'address': '',
        'phone': '',
        'year_established': '',
        'membership_mode': '',
        'description': '',
        'membership_status': 'open',
        'membership_fee': '',
        'member_count': ''
    })
    const [years, setYears] = useState(null)
    const [loading, setLoading] = useState(false)
    const [validationError, setValidationError] = useState({})
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData(prevFormData => (
            { ...prevFormData, [name]: value }
        ))
    }

    const generateYears = () => {
        let currentYear = new Date().getFullYear();
        let startYear = 1980;
        let years = []
        while (startYear <= currentYear) {
            years.push(startYear++);
        }
        setYears(years)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        setValidationError({})
        axiosInstance.post('/association/profile', formData)
            .then(res => {
                toast.success(res.data.message)
                fetchUserDetails()
            })
            .catch(err => {
                toast.error('An error occured. Please, try again')
                if (err.response.status == 422) {
                    setValidationError(err.response.data.errors)
                }
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        setFormData({
            'name': userData?.userInfo?.name,
            'reg_number': userData?.userInfo?.reg_number,
            'email': userData?.userInfo?.email,
            'country': userData?.userInfo?.country_id,
            'state': userData?.userInfo?.state_id,
            'city': userData?.userInfo?.city_id,
            'address': userData?.userInfo?.address,
            'phone': userData?.userInfo?.phone,
            'year_established': userData?.userInfo?.year_established,
            'membership_mode': userData?.userInfo?.membership_mode,
            'membership_status': userData?.userInfo?.membership_status,
            'description': userData?.userInfo?.description,
            'membership_fee': userData?.userInfo?.membership_fee,
            'member_count': userData?.userInfo?.member_count
        })
    }, [userData.userInfo])

    useEffect(() => {
        generateYears()
    }, [])

    useEffect(() => {
        getCountries()
            .then(({data}) => setCountries(data))
            .catch(() => setCountries([]))
    }, [])

    useEffect(() => {
        if (formData.country) {
            getStatesByCountry(formData.country)
                .then(res => setStates(res.data))
                .catch(() => setStates([]));
            setCities([]);
        }
    }, [formData.country]);

    useEffect(() => {
        if (formData.state) {
            getCitiesByState(formData.state)
                .then(res => setCities(res.data))
                .catch(() => setCities([]));
        }
    }, [formData.state])

    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Profile</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Profile</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            <div className="position-relative mx-n4 mt-n4">
                <div className="profile-wid-bg profile-setting-img">
                    <img src="/assets/images/profile-bg.jpg" className="profile-wid-img" alt="" />
                    {/* <div className="overlay-content">
                        <div className="text-end p-3">
                            <div className="p-0 ms-auto rounded-circle profile-photo-edit">
                                <input id="profile-foreground-img-file-input" type="file" className="profile-foreground-img-file-input" />
                                <label for="profile-foreground-img-file-input" className="profile-photo-edit btn btn-light">
                                    <i className="ri-image-edit-line align-bottom me-1"></i> Change Cover
                                </label>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>

            <div className="row">
                <div className="col-lg-3 col-md-4">
                    <div className="card mt-n5">
                        <div className="card-body p-4">
                            <div className="text-center">
                                <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                                    <img src="/assets/images/svg/crypto-icons/eth.svg" className="rounded-circle avatar-xl img-thumbnail user-profile-image" alt="user-profile-image" />
                                </div>
                                <h5 className="fs-16 mb-1">{userData?.userInfo?.name}</h5>
                                <p className="text-muted mb-0">{userData?.userInfo?.reg_number}</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--end card--> */}
                    {/* <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center mb-5">
                                <div className="flex-grow-1">
                                    <h5 className="card-title mb-0">Complete Your Profile</h5>
                                </div>
                                <div className="flex-shrink-0">
                                    <a href="javascript:void(0);" className="badge bg-light text-primary fs-12"><i className="ri-edit-box-line align-bottom me-1"></i> Edit</a>
                                </div>
                            </div>
                            <div className="progress animated-progress custom-progress progress-label">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "30%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                    <div className="label">30%</div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center mb-4">
                                <div className="flex-grow-1">
                                    <h5 className="card-title mb-0">Socials</h5>
                                </div>
                                {/* <div className="flex-shrink-0">
                                    <a href="javascript:void(0);" className="badge bg-light text-primary fs-12"><i className="ri-add-fill align-bottom me-1"></i> Add</a>
                                </div> */}
                            </div>
                            <AssociationSocials
                                socialDetails={userData}
                                fetchUserProfile={fetchUserDetails}
                            />
                        </div>
                    </div>
                    {/* <!--end card--> */}
                </div>
                {/* <!--end col--> */}
                <div className="col-lg-9 col-md-4">
                    <div className="card mt-xxl-n5">
                        <div className="card-header">
                            <ul className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#personalDetails" role="tab">
                                        <i className="fas fa-home"></i> Association Details
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="card-body p-4">
                            <div className="tab-content">
                                <div className="tab-pane active" id="personalDetails" role="tabpanel">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label for="associationName" className="form-label">Association Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="associationName"
                                                        placeholder="Enter Association Name"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                    />
                                                    {validationError.name && <small className='text-danger my-1'>{validationError.name[0]}</small>}
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label for="regNumber" className="form-label">Registration Number</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="regNumber"
                                                        placeholder="Enter registration number"
                                                        value={formData.reg_number}
                                                        name="reg_number"
                                                        onChange={handleChange}
                                                    />
                                                    {validationError.reg_number && <small className='text-danger my-1'>{validationError.reg_number[0]}</small>}
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label for="email" className="form-label">Email Address</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        id="email"
                                                        placeholder="Enter email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                    />
                                                    {validationError.email && <small className='text-danger my-1'>{validationError.email[0]}</small>}
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className="col-lg-4">
                                                <div className="mb-3">
                                                    <label for="phonenumberInput" className="form-label">Phone Number</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="phonenumberInput"
                                                        placeholder="Enter phone number"
                                                        value={formData.phone}
                                                        name="phone"
                                                        onChange={handleChange}
                                                    />
                                                    {validationError.phone && <small className='text-danger my-1'>{validationError.phone[0]}</small>}
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className="col-lg-2">
                                                <div className="mb-3">
                                                    <label for="phonenumberInput" className="form-label">No. of Members</label>
                                                    <select
                                                        className="form-control"
                                                        id="yearEstablish"
                                                        name="member_count"
                                                        value={formData.member_count}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">-- Select --</option>
                                                        <option value="0-50">0 - 50</option>
                                                        <option value="51-100">51 - 100</option>
                                                        <option value="101-500">101 - 500</option>
                                                        <option value="501-1000">501 - 1000</option>
                                                        <option value="1001-5000">1001 - 50000</option>
                                                    </select>
                                                    {validationError.member_count && <small className='text-danger my-1'>{validationError.member_count[0]}</small>}
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className="col-lg-4">
                                                <div className="mb-3">
                                                    <label for="yearEstablish" className="form-label">Year Established</label>
                                                    <select
                                                        className="form-control"
                                                        id="yearEstablish"
                                                        name="year_established"
                                                        value={formData.year_established}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">-- Select --</option>
                                                        {years && years.map(year => (
                                                            <option value={year} key={year}>{year}</option>
                                                        ))}
                                                    </select>
                                                    {validationError.year_established && <small className='text-danger my-1'>{validationError.year_established[0]}</small>}
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className={formData.membership_mode == 'paid' ? 'col-lg-2' : 'col-lg-4'}>
                                                <div className="mb-3">
                                                    <label for="membershipMode" className="form-label">Membership Mode</label>
                                                    <select
                                                        className="form-control"
                                                        id="membershipMode"
                                                        name="membership_mode"
                                                        value={formData.membership_mode}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={''}>--select--</option>
                                                        <option value={'free'}>Free</option>
                                                        <option value={'paid'}>Paid</option>
                                                    </select>
                                                    {validationError.membership_mode && <small className='text-danger my-1'>{validationError.membership_mode[0]}</small>}
                                                </div>
                                            </div>
                                            {formData.membership_mode == 'paid' && <div className="col-lg-2">
                                                <div className="mb-3">
                                                    <label for="membershipFee" className="form-label">Membership Fee</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="phonenumberInput"
                                                        placeholder="Enter Fee"
                                                        value={formData.membership_fee}
                                                        name="membership_fee"
                                                        onChange={handleChange}
                                                    />
                                                    {validationError.membership_fee && <small className='text-danger my-1'>{validationError.membership_fee[0]}</small>}
                                                </div>
                                            </div>}
                                            {/* <!--end col--> */}
                                            <div className="col-lg-4">
                                                <div className="mb-3">
                                                    <label for="membershipStatus" className="form-label">Membership Status</label>
                                                    <select
                                                        className="form-control"
                                                        id="membershipStatus"
                                                        name="membership_status"
                                                        value={formData.membership_status}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={'open'}>Open</option>
                                                        <option value={'closed'}>Closed</option>
                                                    </select>
                                                    {validationError.membership_status && <small className='text-danger my-1'>{validationError.membership_status[0]}</small>}
                                                </div>
                                            </div>
                                             {/* <!--end col--> */}
                                             <div className="col-lg-4">
                                                <div className="mb-3">
                                                    <label htmlFor="country" className="form-label">Country</label>
                                                    <select
                                                        className="form-control"
                                                        id="country"
                                                        name="country"
                                                        value={formData.country}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">--select--</option>
                                                        {countries.map(c => (
                                                            <option key={c.id} value={c.id}>{c.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="mb-3">
                                                    <label htmlFor="state" className="form-label">State</label>
                                                    <select
                                                        className="form-control"
                                                        id="state"
                                                        name="state"
                                                        value={formData.state}
                                                        onChange={handleChange}
                                                        disabled={!formData.country}
                                                    >
                                                        <option value="">--select--</option>
                                                        {states.map(s => (
                                                            <option key={s.id} value={s.id}>{s.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="mb-3">
                                                    <label htmlFor="city" className="form-label">City</label>
                                                    <select
                                                        className="form-control"
                                                        id="city"
                                                        name="city"
                                                        value={formData.city}
                                                        onChange={handleChange}
                                                        disabled={!formData.state}
                                                    >
                                                        <option value="">--select--</option>
                                                        {cities.map(city => (
                                                            <option key={city.id} value={city.id}>{city.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label for="address" className="form-label">Address</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={4}
                                                        id="address"
                                                        placeholder="Enter Address"
                                                        name="address"
                                                        value={formData.address}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label for="description" className="form-label">Association Bio</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={4}
                                                        id="description"
                                                        placeholder="Enter Description"
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                            <div className="col-lg-12">
                                                <div className="hstack gap-2 justify-content-end">
                                                    <button type="submit" className="btn btn-primary">Update</button>
                                                </div>
                                            </div>
                                            {/* <!--end col--> */}
                                        </div>
                                        {/* <!--end row--> */}
                                        {loading && <Loader />}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}
        </>
    )
}